import api from 'services/api';
import { POST, emailRoutes } from 'constants/api';

// eslint-disable-next-line import/prefer-default-export
export const sendRecommendations = data =>
  api({
    method: POST,
    url: emailRoutes.RECOMMENDATIONS,
    data,
  });

export const saveJdRecommendations = data =>
  api({
    method: POST,
    url: emailRoutes.RECOMMENDATIONS_JD,
    data,
  });
